{
  "id": "campaign-046",
  "name": "Sleepy Farmstead II",
  "seed": "campaign:46",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......zRRRRR",
    "......zRRRRR",
    "..q.zzz_____",
    "............",
    "...#...x....",
    "........#...",
    "fffffff..fff",
    "............",
    ".c.cyczc.c.c",
    "v.....zzzzzz",
    "vT..T..T..Tv",
    "v..........v",
    ".........q.v",
    "....y.......",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "repair",
      "x": 6,
      "y": 3
    }
  ],
  "generatorVersion": 3,
  "level": 46,
  "biome": "farm",
  "par": {
    "reel": 5886,
    "push": 5294,
    "selfPropelled": 4884,
    "tractor": 4650,
    "zeroTurn": 3158,
    "fairway": 2686
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 23,
      "selfPropelled": 13,
      "tractor": 8,
      "zeroTurn": 1,
      "fairway": 4
    }
  }
}
